import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TieScorecardComponent } from './tie-scorecard.component';
import { TranslateModule } from '@ngx-translate/core';
import { InviteTeamOwnerComponent } from './invite-team-owner/invite-team-owner.component';
import { SelectTieTeamComponent } from './select-tie-team/select-tie-team.component';
import { SelectUserModule } from '../../../_shared/components/select-user/select-user.module';
import { SelectTeamComponentModule } from '../../../my-teams/select-team/select-team.module';
import { TieBarComponent } from './tie-bar/tie-bar.component';
import { ShareMatchComponentModule } from '../../../_shared/components/share-match/share-match.module';
import { TrackersModule } from '../../../_shared/components/trackers/trackers.module';
import { EmptyPageModule } from '../../../empty-page/empty-page.module';
import { DownloadTieComponent } from './download-tie/download-tie.component';
import { TeamLogoComponent } from './team-logo/team-logo.component';
import { FollowTieComponent } from '../follow-tie/follow-tie.component';
import { FollowTeamComponent } from '../follow-team/follow-team.component';

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        TranslateModule.forChild(),
        SelectUserModule,
        SelectTeamComponentModule,
        ShareMatchComponentModule,
        EmptyPageModule,
        TrackersModule,
        TeamLogoComponent,
        FollowTieComponent,
        FollowTeamComponent
    ],
    exports: [
        TieScorecardComponent
    ],
    declarations: [
        TieScorecardComponent,
        TieBarComponent,
        DownloadTieComponent,
        
        
    ]
})
export class TieScorecardModule { }
